import Vue from 'vue';
import commonFunc from './common/commonFunction';
import apiConfig from './api/apiConfig';
import messageBox from './common/messageBox';
import MSJson from '@/common/json';
import { MSEnum } from '@/common/enumeration';
import Utility from '@/common/utility';
import authService from '@/auth/authService';

function looseClone(obj) {
	return MSJson.deserialize(MSJson.serialize(obj));
}

const install = Vue => {
	Vue.prototype.$ms = Vue.prototype.$ms ? Vue.prototype.$ms : {};
	Vue.prototype.$ms.commonFunc = commonFunc;
	Vue.prototype.$ms.apiConfig = looseClone(apiConfig);
	Vue.prototype.$ms.msgBox = messageBox;
	Vue.prototype.$ms.msJson = MSJson;
	Vue.prototype.$ms.enum = looseClone(MSEnum); //MSEnum;
	Vue.prototype.$ms.utility = Utility;
	Vue.prototype.$auth = authService;
	Vue.prototype.$onClickEvent = commonFunc.onClickEvent;

	//DNThang - 13.04.2020: Thực hiện nhúng vào toàn bộ các element hàm lấy ra VueInstance tránh dùng __Vue__ không chuẩn tắc
	Vue.mixin({
		mounted() {
			const me = this;
			if (me.$el && !me.$el.getVueInstance) {
				me.$el.getVueInstance = function() {
					return me;
				};
			}
		}
	});
};

install(Vue);

export default install;
